import { memo } from 'react';

export type CellHighlight = 'normal' | 'selected' | 'peer' | 'same' | 'hint';

interface CellProps {
  index: number;
  value: number;
  given: boolean;
  notes: number[];
  highlight: CellHighlight;
  conflict: boolean;
  onSelect: (index: number) => void;
}

function CellImpl({ index, value, given, notes, highlight, conflict, onSelect }: CellProps) {
  const row = Math.floor(index / 9);
  const col = index % 9;
  const classes = [
    'cell',
    `hl-${highlight}`,
    given ? 'given' : 'entered',
    conflict ? 'conflict' : '',
    col % 3 === 2 && col !== 8 ? 'box-right' : '',
    row % 3 === 2 && row !== 8 ? 'box-bottom' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type="button"
      className={classes}
      aria-label={`row ${row + 1} column ${col + 1}${value ? `, ${value}` : ', empty'}`}
      aria-pressed={highlight === 'selected'}
      onClick={() => onSelect(index)}
    >
      {value !== 0 ? (
        <span className="value">{value}</span>
      ) : (
        <span className="notes" aria-hidden>
          {Array.from({ length: 9 }, (_, n) => (
            <span key={n} className="note">
              {notes.includes(n + 1) ? n + 1 : ''}
            </span>
          ))}
        </span>
      )}
    </button>
  );
}

export const Cell = memo(CellImpl);
